import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './Home.css';

import carousel1 from '../assets/home/2021 EPSB Division Recognition.jpeg';
import carousel2 from '../assets/home/2021-22 Tutor Orientation.png';
import carousel3 from '../assets/home/2024-25 Curious Colors.jpg';
import carousel4 from '../assets/home/2020-21 Tutee Orientation.png';

export default function Home() {
  const featureCards = [
    { title: 'Free Tutoring', desc: 'Edmonton-based high school and university tutors provide free tutoring to students in grades K-9.', link: '/apply' },
    { title: 'Resources', desc: 'Look through our Resources for information about our process and supports to guide your tutoring journey.', link: '/resources' },
    { title: 'Inquiries', desc: 'Questions about our process or inquiries about Life Long Learners? All are welcome.', link: '/contact-us' },
  ];

  const carouselImages = [carousel1, carousel2, carousel3, carousel4];

  // Added link fields so each event can be clicked
  const upcomingEvents = [
    //{ date: 'January 20th, 2026 (6:00 - 7:00 PM)', title: 'Learning Level Up (Virtual Event)', desc: 'Join us for an evening of practical study strategies, real student stories, and a live Q&A to help students and parents confidently navigate transitions to upper classes.', link: 'https://docs.google.com/forms/d/e/1FAIpQLSeRKbtsW6-OGIs3FtDuE0wvPmLqP3lnGTMEcYpR72GQgLhk4Q/viewform' },
    { date: 'October 2nd, 2026 (11:59 PM)', title: 'Deadline to become a tutor', desc: 'All Edmonton-based high school and university students wishing to become a tutor by mid-October must sign-up by the above deadline.', link: 'https://forms.gle/6T6kPeqvYX3V9RHz7' },
    { date: 'October 2nd, 2026 (11:59 PM)', title: 'Deadline to receive tutoring', desc: 'All EPSB K-9 students wishing to be paired with a tutor by mid-October must sign-up by the above deadline.', link: 'https://forms.gle/7FUqcLRu68ikL3rB6' },
    //{date: 'April 2026', title: 'April Newsletter', desc: 'Click to read our April newsletter!', link: 'https://drive.google.com/file/d/1bFv3TUbp-Auhq1lBxQYFxmxCaxpK0Daf/view?usp=sharing'},
  ];

  const testimonials = [
    { name: 'William Ye, Tutor', quote: 'My experience with Life Long Learners has been extremely rewarding. When I first began tutoring, I didn\'t have much familiarity in teaching. However, as I began to grow more comfortable, I sharpened my skills and helped my tutee thrive. We both became better, and continue to learn and grow. I love giving back to community, as it has shaped me into the person I am today.' },
    { name: 'Aseem Yadav, Parent', quote: 'I feel extremely fortunate that my son was paired up with (tutor name). She is very dedicated, patient and an excellent teacher. My Grade 1r looks forward to study with her on Fridays and talk in French with her! And as parents who have zero knowledge about French, she is a great help. She also gave us detailed information about junior high and high school. So far my son has been benefitting a lot from this program.' },
    { name: 'Anonymous, Tutee', quote: 'Overall when my tutor and I met, I loved how she was funny, kind, and respectful to me. She helped me with my studies quite well and I got over 80% on my quizzes, tests, and unit tests. I hope we reach out to each other again.' },
    { name: 'Jenna Malhotra, Tutor', quote: 'My experience with Life Long Learners has been an amazing one so far! Helping children in many different subjects has been very fulfilling and I love to spend time with my tutee really getting to know them. The Life Long Learners team is very accommodating and easy to work with as well so it is a great experience overall!' },
    { name: 'Anonymous, Tutee', quote: 'I\'m in grade 8 and the life long learners program is surprisingly fun, I get to learn things that are above grade level or just review while talking to someone who listens and responds with helpful tips etc.' },
    { name: 'Vaishnavi Gopalakrishnan, Tutor', quote: 'This program has done a great job with making me feel welcome and appreciated. My tutee is also a really funny and kind person who I always look forward to helping. In total, I genuinely love this program. I am grateful that I chose to join, and I will continue to join for as many years as possible.'},
    { name: 'Bayan Shayeb, Tutor', quote: 'It was really hard for me to get involved in my community, especially because of my lack of previous experience, but Life Long Learners is non-exclusive and allowed me to gain skill and experience, which I am so grateful for.'},
    { name: 'Anonymous, Tutee', quote: 'I love to learn with (current tutor name) my tutor she helps me so much in terms of school work and we also talk and laugh together and overall Life Long learners is really fun. And last year (past tutor name) was also very funny and helpful and kind.' },
    { name: 'Tara Rehncy, Tutor', quote: 'I got to bond with my tutee and help her with the topics she had trouble with, which led to her grade improving by the end of the year. I encourage anyone to join LLL for an opportunity to make a positive impact on a student’s academic success! :D'},
  ];

  const testimonialSlides = [];
  for (let i = 0; i < testimonials.length; i += 3) {
    testimonialSlides.push(testimonials.slice(i, i + 3));
  }

  return (
    <div className="home-page">
      {/* Hero Section */}
      <motion.section className="hero-section"
        initial={{ opacity: 0, y: -50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8 }}
      >
        <h1 className="hero-title">Life Long Learners</h1>
        <p className="hero-subtitle">A free tutoring program for the students, by the students.</p>
        <Link to='/apply'><button className='btn hero-btn'>Apply Now</button></Link>
      </motion.section>

      {/* Carousel + Timeline Section */}
      <motion.section className="carousel-timeline-section"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        <div className="carousel-container">
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            navigation={true}
            pagination={{ clickable: true }}
            loop={true}
            autoplay={{ delay: 4000 }}
          >
            {carouselImages.map((url, index) => (
              <SwiperSlide key={index}>
                <img src={url} alt={`Slide ${index + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="timeline-container">
          <h2>Bulletin Board</h2>

        <div className="timeline-scroll">
          {upcomingEvents.map((event, idx) => (
            <a
              key={idx}
              href={event.link}
              target="_blank"
              rel="noopener noreferrer"
              className="timeline-event clickable-event"
            >
              <p className="timeline-date">{event.date}</p>
              <h4 className="timeline-title">{event.title}</h4>
              <p className="timeline-desc">{event.desc}</p>
            </a>
          ))}
          </div>
        </div>
      </motion.section>

      {/* Feature Cards */}
      <motion.section className="feature-cards-section"
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        transition={{ delay: 0.4 }}
      >
        <div className="feature-cards">
          {featureCards.map((card, idx) => (
            <Link to={card.link} key={idx} className="feature-link">
              <motion.div 
                whileHover={{ scale: 1.05 }} 
                className="feature-card"
              >
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </motion.div>
            </Link>
          ))}
        </div>
      </motion.section>

      {/* Testimonials Section */}
      <motion.section className="testimonials-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        <h2 className="testimonial-header">Testimonials</h2>
        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 8000 }}
          pagination={{ clickable: true }}
        >
          {testimonialSlides.map((group, idx) => (
            <SwiperSlide key={idx}>
              <div className="testimonial-slide">
                {group.map((t, i) => (
                  <div key={i} className="testimonial-card">
                    <p className="testimonial-quote">"{t.quote}"</p>
                    <p className="testimonial-name">- {t.name}</p>
                  </div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.section>
    </div>
  );
}
